import React, { FC } from 'react';
import Headphones from 'components/Common/Icons/opplus/Headphones';
import styles from './AdditionalOptions.module.scss';

export interface AdditionalOptionsProps {
  title: string;
  helpText: string;
  contactCsUrl: string;
  contactCsTxt: string;
}

const AdditionalOptions: FC<AdditionalOptionsProps> = ({ contactCsTxt, contactCsUrl, helpText, title }) => {
  return (
    <>
      <h2 className={styles.subHeading}>{title}</h2>
      <div dangerouslySetInnerHTML={{ __html: helpText }} className={styles.needHelp} />
      <a href={contactCsUrl} className={styles.customerSupport}>
        <Headphones />
        <span className={styles.customerSupportText}>{contactCsTxt}</span>
      </a>
    </>
  );
};

export default AdditionalOptions;
